import React from 'react';
import { Star, CurrencyDollar } from '@phosphor-icons/react';
import { Button } from '../ui/button';

export default function EarningsTab({ workerStats, navigate }) {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl p-6 shadow-[4px_4px_0px_#000] dark:shadow-[4px_4px_0px_#2B4C6F]">
        <h2 className="text-2xl font-black text-neutral-900 dark:text-white mb-6">Earnings Overview</h2>
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="p-6 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl border-2 border-emerald-200 dark:border-emerald-800">
            <p className="text-sm text-neutral-600 dark:text-neutral-400 font-bold mb-1">This Month</p>
            <p className="text-3xl font-black text-neutral-900 dark:text-white">${workerStats.earnings?.toLocaleString() || 0}</p>
            <p className="text-sm text-emerald-600 dark:text-emerald-400 mt-1 font-medium">From released escrows</p>
          </div>
          <div className="p-6 bg-[#2B4C6F]/10 dark:bg-[#2B4C6F]/20 rounded-xl border-2 border-[#2B4C6F]/30 dark:border-[#2B4C6F]/50">
            <p className="text-sm text-neutral-600 dark:text-neutral-400 font-bold mb-1">Active Jobs</p>
            <p className="text-3xl font-black text-neutral-900 dark:text-white">{workerStats.activeProjects}</p>
            <p className="text-sm text-[#2B4C6F] mt-1 font-medium">In progress</p>
          </div>
          <div className="p-6 bg-amber-50 dark:bg-amber-900/20 rounded-xl border-2 border-amber-200 dark:border-amber-800">
            <p className="text-sm text-neutral-600 dark:text-neutral-400 font-bold mb-1">Your Rating</p>
            <div className="flex items-center gap-2">
              <p className="text-3xl font-black text-neutral-900 dark:text-white">{workerStats.rating?.toFixed(1) || '0.0'}</p>
              <Star size={28} weight="fill" className="text-amber-500" />
            </div>
            <p className="text-sm text-amber-600 dark:text-amber-400 mt-1 font-medium">{workerStats.reviews} reviews</p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl p-6 shadow-[4px_4px_0px_#000] dark:shadow-[4px_4px_0px_#2B4C6F]">
        <h3 className="text-xl font-black text-neutral-900 dark:text-white mb-4">Escrow Payments</h3>
        <p className="text-neutral-600 dark:text-neutral-400 mb-4">View and manage your escrow payments in the Escrow Dashboard.</p>
        <button onClick={() => navigate('/escrow')} className="h-12 px-6 bg-[#2B4C6F] text-white font-bold rounded-xl border-2 border-black shadow-[3px_3px_0px_#000] hover:shadow-[4px_4px_0px_#000] active:translate-y-1 active:shadow-none transition-all">
          Go to Escrow Dashboard
        </button>
      </div>

      <div className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl p-6 shadow-[4px_4px_0px_#000] dark:shadow-[4px_4px_0px_#2B4C6F]">
        <h3 className="text-xl font-black text-neutral-900 dark:text-white mb-4">Payment Method</h3>
        <div className="border-2 border-neutral-200 dark:border-neutral-700 rounded-lg p-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <CurrencyDollar size={32} weight="bold" className="text-neutral-400" />
            <div>
              <p className="font-bold text-neutral-900 dark:text-white">Direct Deposit</p>
              <p className="text-sm text-neutral-600 dark:text-neutral-400">Connect your bank account to receive payments</p>
            </div>
          </div>
          <Button variant="outline" size="sm" className="border-2 border-black dark:border-neutral-600 font-bold">Setup</Button>
        </div>
      </div>
    </div>
  );
}
